import { DependencyList, useEffect } from "react";

/**
 * Corre `callback` cuando `deps` deja de cambiar durante `delay` ms. Cada cambio nuevo cancela el
 * temporizador anterior, así que solo se ejecuta la última versión — lo que se necesita cuando la
 * acción es cara (una llamada al API) y el disparador es texto que se escribe carácter por carácter.
 *
 * Al desmontar también se cancela, para no correr el efecto sobre un componente que ya no existe.
 *
 * ```tsx
 * useDebouncedEffect(() => autoguardar("contacto"), [autoguardar], 1500);
 * ```
 */
function useDebouncedEffect(callback: () => void, deps: DependencyList, delay: number) {
  useEffect(
    () => {
      const timer = setTimeout(callback, delay);
      return () => clearTimeout(timer);
    },
    // Las dependencias las decide quien usa el hook, así que la regla no puede verificarlas aquí.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...deps, delay],
  );
}

export default useDebouncedEffect;
